import { useState, useEffect, useCallback } from "react";
import { apiService } from "../api/services/apiService";
import type { Category } from "../types";

export const useCategories = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchCategories = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await apiService.getCategories();
      setCategories(data);
    } catch (err: any) {
      console.error(err);
      setError(err.message || "Failed to fetch categories");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  const refresh = () => fetchCategories();

  return { categories, loading, error, refresh };
};
